var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeSolid = function SvgHomeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M17.5 9.375v7.5a.625.625 0 0 1-.625.625H3.125a.625.625 0 0 1-.625-.625v-7.5a1.24 1.24 0 0 1 .366-.884l6.25-6.25a1.25 1.25 0 0 1 1.768 0l6.25 6.25a1.24 1.24 0 0 1 .366.884"
  })));
};
export default SvgHomeSolid;